export default "__VITE_ASSET__a4e754fb__"